<template>
  <div class="info">
    <div class="head-wrap content-padding">
      <img v-if="companyId != 0" src="@/assets/huada/head-img.png" class="head-img" />
      <img v-if="companyId == 0" src="@/assets/huada/head-img1.png" class="head-img1" />
    </div>
    <div class="content-padding">
      <div class="section-content" v-if="orgId != 1117">
        <img class="sec-title" src="@/assets/huada/block-1.png" />
        <div class="manage-info manage-info-title content">
          <div class="manage-info_content" style="padding-top: 0">
            <div class="input-wrap">
              <div class="key">业务员姓名</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonName"
                  placeholder="请输入姓名"
                />
              </div>
            </div>
            <div class="input-wrap">
              <div class="key">业务员工号</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonNo"
                  placeholder="请输入业务员工号"
                />
              </div>
            </div>
            <div class="input-wrap" style="margin-bottom: 0">
              <div class="key">业务员手机号</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonPhone"
                  placeholder="请输入手机号"
                />
              </div>
            </div>
            <div class="input-wrap" style="margin-bottom: 0">
              <div class="key">机构名称</div>
              <div class="val">
                <van-field
                  :value="saleOrgNameDisplay"
                  readonly
                  type="text"
                  placeholder="—"
                />
              </div>
            </div>
            <div v-if="orgId == 1148" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columns1148"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1164" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columns1164"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1124" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columns"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1132" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columnsChangZhou"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="content" style="margin-top: -40px">
          <div
            class="manage-info manage-info-repeat"
            v-for="(item, index) in form.itemList"
            :key="index"
          >
            <!-- <div class="manage-info_header person-title" v-if="index == 0">
              <h4>客户个人信息</h4>
              <p>以人为本破除久医不治枷锁</p>
          
            </div> -->
            <div class="manage-info_content">
            <section class="section-content">
                <img class="sec-title" src="@/assets/huada/block-3.png" />
                <div class="project-list">
                  <ul v-for="(listItem, listIndex) in list" :key="listIndex">
                    <li
                      v-for="projectItem in listItem"
                      :key="projectItem.id"
                      :class="[
                        {
                          active: item.productList.find(
                            (item) => item.productId == projectItem.id
                          ),
                        },
                      ]"
                      @click="onHandleChoice(index, projectItem)"
                    >
                      <p class="title">{{ projectItem.name }}</p>
                      <p class="title">{{ projectItem.tag }}</p>
                      <p class="middle"></p>
                      <p>￥{{ projectItem.label }}</p>
                      <div
                        class="item-success"
                        v-if="
                          item.productList.find(
                            (item) => item.productId == projectItem.id
                          )
                        "
                      >
                        <img src="@/assets/huada/select.png" />
                      </div>
                    </li>
                  </ul>
                </div>
              </section>
              <section class="section-content">
                <img class="sec-title" src="@/assets/huada/block-2.png" />
                <div class="input-wrap">
                  <div class="key">姓名</div>
                  <div class="val">
                    <van-field
                      v-model="item.personName"
                      placeholder="请输入姓名"
                    />
                  </div>
                </div>
                <div class="input-wrap">
                  <div class="key">身份证号</div>
                  <div class="val">
                    <van-field
                      v-model="item.personIdCard"
                      placeholder="请输入身份证号"
                    />
                  </div>
                </div>
                <div class="input-wrap">
                  <div class="key">手机号</div>
                  <div class="val">
                    <van-field
                      v-model="item.personPhone"
                      placeholder="请输入手机号"
                    />
                  </div>
                </div>
              <div v-if="item.productList.find((item) => item.productId == 5)" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">民族</div>
              <div class="val">
                <van-field
                  v-model="item.nation"
                  readonly
                  placeholder="请选择民族"
                  @click="onOpenNationPicker(index)"
                />
                <van-popup v-model="showPickerNation" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columnsNation"
                    :default-index="selectedNationIndex"
                    @confirm="onConfirmNation"
                    @cancel="showPickerNation = false"
                  />
                </van-popup>
              </div>
            </div>
            <div
                  class="input-wrap"
                  v-if="item.productList.find((item) => item.productId == 5)"
                >
                  <div class="key">籍贯</div>
                  <div class="val">
                    <van-field
                      v-model="item.origin"
                      readonly
                      placeholder="请选择籍贯"
                      @click="onOpenOriginPicker(index)"
                    />
                    <van-popup v-model="showPickerOrigin" position="bottom">
                      <van-picker
                      show-toolbar
                        :columns="columnsOrigin"
                        :default-index="selectedOriginIndex"
                        @confirm="onConfirmOrigin"
                        @cancel="showPickerOrigin = false"
                      />
                    </van-popup>
                  </div>
                </div>
                <div class="input-wrap" v-if="companyId != 0">
                  <div class="key">开始日期</div>
                  <div class="val">
                    <van-cell-group>
                      <van-cell
                        :title="form.itemList[index]['checkStartTime']"
                        @click="onHandleChoiceDate(index)"
                        :class="[{ link: !isLink }]"
                      >
                        <template #right-icon>
                          <img
                            class="right-icon"
                            src="@/assets/huada/icon-clock.png"
                          />
                        </template>
                      </van-cell>
                      <van-calendar
                        v-model="show"
                        :min-date="minDate"
                        @confirm="onConfirm"
                        color="#07A8FF"
                      />
                    </van-cell-group>
                  </div>
                </div>
                <div
                  class="input-wrap"
                  v-if="item.productList.find((item) => item.productId == 1)"
                >
                  <div class="key">邮寄地址</div>
                  <div class="val">
                    <van-field
                      v-model="item.addressName"
                      placeholder="请输入邮寄地址"
                    />
                  </div>
                </div>
                <div
                  class="input-wrap"
                  v-if="item.productList.find((item) => item.productId == 7)"
                >
                  <div class="key">邮寄地址</div>
                  <div class="val">
                    <van-field
                      v-model="item.addressName"
                      placeholder="请输入邮寄地址"
                    />
                  </div>
                </div>
                <div
                  class="input-wrap"
                  v-if="item.productList.find((item) => item.productId == 2)"
                >
                  <div class="key">身高(cm)</div>
                  <div class="val">
                    <van-field v-model="item.height" placeholder="请填写身高" />
                  </div>
                </div>
                <div
                  class="input-wrap"
                  v-if="item.productList.find((item) => item.productId == 2)"
                >
                  <div class="key">体重(kg)</div>
                  <div class="val">
                    <van-field v-model="item.weight" placeholder="请填写体重" />
                  </div>
                </div>
                <div
                  class="input-wrap"
                  v-if="item.productList.find((item) => item.productId == 5)"
                >
                  <div class="key">身高(cm)</div>
                  <div class="val">
                    <van-field v-model="item.height" placeholder="请填写身高" />
                  </div>
                </div>
                <div
                  class="input-wrap"
                  v-if="item.productList.find((item) => item.productId == 5)"
                >
                  <div class="key">体重(kg)</div>
                  <div class="val">
                    <van-field v-model="item.weight" placeholder="请填写体重" />
                  </div>
                </div>
                 <div v-if="item.productList.find((item) => item.productId == 5 || item.productId == 6)" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">是否当日应用</div>
              <div class="val">
                <van-field
                  v-model="item.todayFlag"
                  readonly
                  placeholder="请选择是否当日应用"
                  @click="onOpenTodayPicker(index)"
                />
                <van-popup v-model="showPickerToday" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columnsToday"
                    :default-index="selectedTodayIndex"
                    @confirm="onConfirmToday"
                    @cancel="showPickerToday = false"
                  />
                </van-popup>
              </div>
            </div>
              </section>
             
              <section
                class="money section-content"
                v-if="item.productList.length"
              >
                <img class="sec-title" src="@/assets/huada/block-4.png" />
                <!-- <div class="money-title label" style="margin-top:16px;font-weight: 500;">项目费用</div> -->
                <div
                  v-for="(expendItem, expendIndex) in expendList"
                  :key="expendIndex"
                  class="money-info"
                >
                  <div
                    v-if="
                      item.productList.find(
                        (item) => item.productId == expendItem.id
                      )
                    "
                    class="money-info_content"
                  >
                    <span>{{ expendItem.name }}{{ expendItem.tag }}</span>
                    <span
                      style="display: flex; align-items: center"
                      >￥{{ expendItem.label }}
                      &nbsp;&nbsp;<van-stepper
                        @change="stepperChange(index)"
                        v-model="
                          item.productList.find(
                            (item) => item.productId == expendItem.id
                          ).productCount
                        "
                        integer
                    /></span>
                  </div>
                </div>
                <div
                  class="money-footer"
                >
                  <span>总计</span>
                  <span class="van-text-cus">￥<van-field
                    v-model="item.sum"
                    @input="onManualSumInput(index, $event)"
                    placeholder="请输入支付金额"
                /></span>
                  <span v-if="item.isGift" class="discount-display">{{ item.isGift }}折</span>
                </div>
              </section>
              <!-- <div class="remove-info">
                <div
                  class="remove-user flex flex-column-center"
                  @click="onHandleRemove(index)"
                ></div>
              </div> -->
            </div>
          </div>
          <!-- 添加按钮 -->
          <!-- <div class="add-info">
            <div class="add-user flex flex-column-center" @click="onHandleAdd">
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="info-footer flex flex-between flex-align-center">
      <dl>
        <dt>总计</dt>
        <dd>￥{{ sum }}</dd>
      </dl>
      <div class="info-footer_right">
        <div class="save btn" @click="onHandleSave"></div>
        <div class="pay-now btn" @click="onHandleSubmit"></div>
      </div>
    </div>
    <van-overlay :show="loading">
      <van-loading size="40" vertical class="loadingDiv">支付中...</van-loading>
    </van-overlay>
  </div>
</template>
<script>
import { Toast } from "vant";
import {
  list,
  expendList,
  org1184List,
  expendOrg1184List,
  item,
} from "./config";
import {
  onSettleInfoSubmitHuaDaVip,
  selPayOrgInfoByOrgIdNew,
} from "@/api";
import { weixinInit } from "@/utils/wechatUtil.js";
const ORG_WANG_ID = 1117;
const ORG_1184_ID = 1184;

export default {
  data() {
    return {
      columns: ['张家港', '常熟', '太仓', '昆山', '吴江', '吴中', '相城', '营销二部', '营销三部','城区收展'],
      columnsChangZhou: ['武进', '直属', '拓展', '收展', '钟新', '溧阳', '金坛'],
      columnsNation: ['汉族', '壮族', '回族', '满族', '维吾尔族', '苗族', '彝族', '土家族', '藏族', '蒙古族', '侗族', '布依族', '瑶族', '白族', '朝鲜族', '哈尼族', '黎族', '哈萨克族', '傣族', '畲族', '傈僳族', '东乡族', '仡佬族', '拉祜族', '佤族', '水族', '纳西族', '羌族', '土族', '仫佬族', '锡伯族', '柯尔克孜族', '景颇族', '达斡尔族', '撒拉族', '布朗族', '毛南族', '塔吉克族', '普米族', '阿昌族', '怒族', '鄂温克族', '京族', '基诺族', '德昂族', '保安族', '俄罗斯族', '裕固族', '乌孜别克族', '门巴族', '鄂伦春族', '独龙族', '赫哲族', '高山族', '珞巴族', '塔塔尔族'],
      columns1148: ['海安', '如皋', '如东', '通州', '海门', '启东', '二部', '城收'],
      columns1164: ['赣榆', '东海', '灌云', '灌南', '连云', '城营', '城收'],

      columnsOrigin: [
        '北京市', '天津市', '河北省', '山西省', '内蒙古自治区', '辽宁省', '吉林省', '黑龙江省',
        '上海市', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省', '河南省',
        '湖北省', '湖南省', '广东省', '广西壮族自治区', '海南省', '重庆市', '四川省',
        '贵州省', '云南省', '西藏自治区', '陕西省', '甘肃省', '青海省', '宁夏回族自治区',
        '新疆维吾尔自治区'
      ],
      columnsToday: ['是', '否'],
      currentItemIndex:0,
      title: "请选择日期",
      isLink: true,
      show: false,
      loading: false,
      selectedUnitIndex: 0,
      selectedNationIndex: 0,
      selectedOriginIndex: 0,
      selectedTodayIndex:0,
      // wxCode: code,
      urlString: "",
      showPicker: false,
      showPickerNation: false,
      showPickerOrigin: false,
      showPickerToday: false,
      list,
      expendList,

      form: {
        payPersonName: "", // 业务员姓名
        payPersonNameOrigin:"",//业务员原名
        payPersonNo: "", // 业务员工号
        payPersonPhone: "", // 业务员手机号
        payPersonCompany:"",//业务员单位
        itemList: [JSON.parse(JSON.stringify(item))],
      },
      ORG_1183: 1183,
      selPayOrgInfo: {},
      sum: 0, // 总计
      orgId: "",
      currentItem: null,
      currentIndex: 0,
      areaCode: "",
    };
  },
  computed: {
    saleOrgNameDisplay() {
      const d = this.selPayOrgInfo;
      if (!d) return "";
      if (d.selPayOrgInfo && d.selPayOrgInfo.saleOrgName) {
        return d.selPayOrgInfo.saleOrgName;
      }
      return d.saleOrgName || "";
    },
  },
  async created() {
    var currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 1);
    this.minDate = currentDate;
    this.orgId = localStorage.getItem("orgId") || "";
    this.companyId = localStorage.getItem("companyId") || "";
    this.areaCode = localStorage.getItem("areaCode") || "";
    this.urlString = window.location.href.split("#")[0];
    const form = localStorage.getItem("pdm_cache_huaDaVip");
    if (form) {
      this.form = JSON.parse(form);
      this.onGetTotalSum();
    }
    this.list = list;
    this.expendList = expendList;

    // 根据 orgId 判断，如果等于 1183，只展示基因溯源和华大壹号
    if (this.orgId == this.ORG_1183) {
      // 复制一份列表，避免修改原始配置数组
      this.list = JSON.parse(JSON.stringify(this.list));
      this.expendList = JSON.parse(JSON.stringify(this.expendList));

      // 只保留基因溯源(id=5)和华大壹号(id=6)
      this.list = this.list.map(listItem => {
        return listItem.filter(item => item.id == 5 || item.id == 6);
      });
      this.expendList = this.expendList.filter(item => item.id == 5 || item.id == 6);
    }

    if (this.orgId == ORG_1184_ID) {
      this.list = org1184List;
      this.expendList = expendOrg1184List;

      const allowedProductIds = [5, 11];
      this.form.itemList.forEach((row) => {
        const productList = row.productList || [];
        const filteredProductList = productList.filter((product) =>
          allowedProductIds.includes(Number(product.productId))
        );
        if (filteredProductList.length !== productList.length) {
          row.productList = filteredProductList;
          row.sum = "";
          row.isGift = null;
        }
      });
    }

    // 根据 areaCode 判断，如果等于 3，华大壹号价格为 8999
    // 注意：这个逻辑在 orgId 特殊处理之后执行，不冲突
    if (this.areaCode == "3") {
      // 复制一份列表，避免修改原始配置数组
      this.list = JSON.parse(JSON.stringify(this.list));
      this.expendList = JSON.parse(JSON.stringify(this.expendList));

      this.list.forEach(listItem => {
        listItem.forEach(item => {
          if (item.id == 6 && item.name == "华大壹号") {
            item.label = 8999;
          }
        });
      });
      this.expendList.forEach(item => {
        if (item.id == 6 && item.name == "华大壹号") {
          item.label = 8999;
        }
      });
    }

    this.form.itemList.forEach((row) => {
      if (row.sum === 0 || row.sum === "") {
        row.sum = "";
      }
    });
    await this.getPayOrgInfo();
    this.wxConfigInit();
  },
  methods: {
    // 打开民族选择器时记录索引
  onOpenNationPicker(index) {
    this.currentItemIndex = index;
    this.showPickerNation = true;
  },
  // 打开籍贯选择器时记录索引
  onOpenOriginPicker(index) {
    this.currentItemIndex = index;
    this.showPickerOrigin = true;
  },
  // 打开当日应用选择器时记录索引
  onOpenTodayPicker(index) {
    this.currentItemIndex = index;
    this.showPickerToday = true;
  },
    onConfirmUnit(value, index) {
      this.form.payPersonCompany = value;
      this.selectedUnitIndex = index;
      this.showPicker = false;
    },
    onConfirmNation(value, index){
      this.showPickerNation = false;
      this.form.itemList[this.currentItemIndex].nation = value;
      this.selectedNationIndex = index;
    },
    onConfirmOrigin(value, index){
      this.showPickerOrigin = false;
      this.form.itemList[this.currentItemIndex].origin = value;
      this.selectedOriginIndex = index;
    },
    onConfirmToday(value, index){
      this.showPickerToday = false;
      this.form.itemList[this.currentItemIndex].todayFlag = value;
      this.selectedTodayIndex = index;
    },
  async getPayOrgInfo() { // 保持 async
 
  let orgIdParam = this.orgId;
  try {
    console.log('API调用');
    const res = await selPayOrgInfoByOrgIdNew({ // 用 await 替换 .then()
      orgId: orgIdParam,
    });
    console.log('API 返回 res:', res);
    console.log('res.code:', res?.code); // 安全访问
    if (res.code == 200) {
      this.selPayOrgInfo = res.data;
    }
  } catch (err) {
    console.error('API 调用失败:', err);
    // 可加 Toast 提示用户
    Toast('加载机构信息失败，请重试');
  }
},
    onHandleChoiceDate(index) {
      this.currentIndex = index;
      this.currentItem = this.form.itemList[index];
      this.show = true;
    },
    onPad(num) {
      return num < 10 ? "0" + num : num;
    },
    formatDate(date) {
      return `${date.getFullYear()}-${this.onPad(
        date.getMonth() + 1
      )}-${this.onPad(date.getDate())}`;
    },
    onConfirm(date) {
      this.show = false;
      // console.log("this.formatDate(date)", this.formatDate(date));
      // this.date = this.formatDate(date);
      this.form.itemList[this.currentIndex]["checkStartTime"] =
        this.formatDate(date);
      this.isLink = false;
      this.title = this.form.itemList[this.currentIndex]["checkStartTime"];
    },
    async wxConfigInit() {
      let weixinShare = {
        publicType: 1,
        url: this.urlString,
      };
      await weixinInit(weixinShare);
    },
    //唤起微信支付
    async weixinPay(weixinPayParam) {
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
        }
      } else {
        this.onBridgeReady(weixinPayParam);
      }
    },
    async onBridgeReady(weixinPayParam) {
      let payNoDiy = weixinPayParam.payNo;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: weixinPayParam.appId,
          timeStamp: weixinPayParam.timeStamp,
          nonceStr: weixinPayParam.nonceStr,
          package: weixinPayParam.packages,
          signType: weixinPayParam.signType,
          paySign: weixinPayParam.paySign,
        },
        function (res) {
          window.location.href =
            "https://yisheng.healthmore.net/settleInfoSuccess?payNo=" +
            payNoDiy;
          //this.$router.push(`/paysuccess?payNo=${payNoDiy}`);
        }
      );
    },
    // 添加用户
    onHandleAdd() {
      const newItem = JSON.parse(JSON.stringify(item));
      newItem.sum = "";
      this.form.itemList.push(newItem);
    },
    //删除用户
    onHandleRemove(index) {
      if (this.form.itemList.length === 1) {
        Toast("至少保留一个用户信息");
        return;
      }
      // 删除指定索引的用户信息
      this.form.itemList.splice(index, 1);
      // 更新总金额
      this.onGetTotalSum();
    },
    // 手动输入金额后计算折扣
    onManualSumInput(index, val) {
      this.form.itemList[index].sum = val;
      this.calculateDiscount(index);
      this.onGetTotalSum();
    },
    // 计算折扣：(实际支付金额 / 原价总和) * 10，进一法保留两位小数
    calculateDiscount(index) {
      const productList = this.form.itemList[index]["productList"];
      const sumInput = Number(this.form.itemList[index]["sum"]);

      // 计算原价总和
      const originalTotal = productList.reduce((sum, item) => {
        return sum + item.productPrice * item.productCount;
      }, 0);

      if (originalTotal > 0 && sumInput > 0) {
        // 计算折扣：(实际支付 / 原价) * 10
        const discount = (sumInput / originalTotal) * 10;
        // 去尾法保留两位小数：乘以100后向下取整，再除以100
        this.form.itemList[index]["isGift"] = Math.floor(discount * 100) / 100;
      } else {
        this.form.itemList[index]["isGift"] = null;
      }
    },
    // 选择产品
    onHandleChoice(index, item) {
      const productList = this.form.itemList[index]["productList"];
      const selectIndex = productList.findIndex(
        (item2) => item2.productId == item.id
      );
      if (selectIndex != -1) {
        productList.splice(selectIndex, 1);
      } else {
        productList.push({
          productId: item.id,
          productCount: 1,
          productPrice: item.label,
        });
      }
      // 重新计算折扣
      this.calculateDiscount(index);
      this.onGetTotalSum();
    },
    stepperChange(listIdx) {
      // 数量变化后重新计算折扣
      this.calculateDiscount(listIdx);
      this.onGetTotalSum();
    },
    onUpCalculation() {
      this.onGetTotalSum();
    },
    // 计算总金额
    onGetTotalSum() {
      let sum = 0;
      this.form.itemList.forEach((row) => {
        if (row.sum !== "" && row.sum != null) {
          const n = Number(row.sum);
          if (!isNaN(n)) {
            sum += n;
          }
        }
      });
      this.sum = sum;
    },
    // 暂存
    onHandleSave() {
      localStorage.setItem("pdm_cache_huaDaVip", JSON.stringify(this.form));
      Toast("暂存成功");
    },
    // 去支付
    onHandleSubmit() {
      console.log("this.form", JSON.parse(JSON.stringify(this.form)));
      if (this.orgId == 1117) {
        this.form.payPersonName = "无需填写";
        this.form.payPersonNo = "00000000000000";
        this.form.payPersonPhone = "11111111111";
      }
      if (!this.form.payPersonName) {
        Toast("请填写业务员姓名");
        return false;
      }

      if (!this.form.payPersonNo) {
        Toast("请填写业务员工号");
        return false;
      }
      if (!this.form.payPersonPhone) {
        Toast("请先输入业务员手机号");
        return;
      }
      if((this.orgId == 1124 || this.orgId == 1132 || this.orgId == 1148 || this.orgId == 1164) && !this.form.payPersonCompany){
        Toast("请先选择业务员单位");
        return;
      }
     
      if (this.form.payPersonPhone.length != 11) {
        Toast("请输入正确的业务员手机号");
        return;
      }
      const list = this.form.itemList;
      for (let i = 0; i < list.length; i++) {
        if (!list[i].personName) {
          Toast("请填写客户姓名");
          return false;
        }
        if (!list[i].personIdCard) {
          Toast("请填写客户客户身份证号");
          return false;
        }
        if (!list[i].personPhone) {
          Toast("请填写客户手机号");
          return false;
        }
        if (list[i].personPhone.length != 11) {
          Toast("请输入正确的客户手机号");
          return;
        }
        if (this.companyId != 0 && !list[i].checkStartTime) {
          Toast("请选择检查日期");
          return;
        }
        if (!list[i].productList.length) {
          Toast("请至少选择一个项目");
          return false;
        }
        if (
          list[i].productList.find((item) => item.productId == 1) &&
          !list[i].addressName
        ) {
          Toast("请填写邮寄地址");
          return false;
        }
        if (
          list[i].productList.find((item) => item.productId == 5) &&
          !list[i].nation
        ) {
          Toast("请选择民族");
          return false;
        }
        if (
          list[i].productList.find((item) => item.productId == 5) &&
          !list[i].origin
        ) {
          Toast("请选择籍贯");
          return false;
        }
        if (
          list[i].productList.find((item) => item.productId == 5) &&
          !list[i].todayFlag
        ) {
          Toast("请选择是否当日应用");
          return false;
        }
        if (
          list[i].productList.find((item) => item.productId == 6) &&
          !list[i].todayFlag
        ) {
          Toast("请选择是否当日应用");
          return false;
        }
        if (
          list[i].productList.find((item) => item.productId == 7) &&
          !list[i].addressName
        ) {
          Toast("请填写邮寄地址");
          return false;
        }
        if (
          list[i].productList.find((item) => item.productId == 2) &&
          !list[i].height
        ) {
          Toast("请填写身高");
          return false;
        }
        if (
          list[i].productList.find((item) => item.productId == 2) &&
          !list[i].weight
        ) {
          Toast("请填写体重");
          return false;
        }
        if (
          list[i].productList.find((item) => item.productId == 5) &&
          !list[i].height
        ) {
          Toast("请填写身高");
          return false;
        }
        if (
          list[i].productList.find((item) => item.productId == 5) &&
          !list[i].weight
        ) {
          Toast("请填写体重");
          return false;
        }
        const payNum = Number(list[i].sum);
        if (
          list[i].sum === "" ||
          list[i].sum === null ||
          list[i].sum === undefined ||
          isNaN(payNum) ||
          payNum <= 0
        ) {
          Toast("请填写大于0的支付金额");
          return false;
        }
      }
      this.onHandleFinalSumit();
    },
    // 提交接口
    async onHandleFinalSumit() {
      this.loading = true;
      let code = localStorage.getItem("code") || "";
      const itemListPayload = this.form.itemList.map((row) => ({
        ...row,
        sum: Number(row.sum),
        productList: row.productList.map((p) => ({
          ...p,
          productPrice: Number(p.productPrice),
        })),
      }));

      // 取第一个用户的折扣作为顶层折扣
      const isGift = this.form.itemList[0]?.isGift || null;

      let values = {
        wxCode: code,
        saleOrgId: this.orgId,
        areaCode: this.areaCode,
        ...this.form,
        isGift: isGift,
        itemList: itemListPayload,
      };
      //console.log("发送给后台的数据:", JSON.stringify(values, null, 2));
      try {
        const res = await onSettleInfoSubmitHuaDaVip(values);
        console.log("res", res);
        if (res.code == 200) {
          this.weixinPay(res.data);
        } else {
          this.$toast(res.msg);
          this.loading = false;
        }
      } catch (err) {
        console.log("err", err);
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.van-text-cus {
  display: flex;
  align-items: center;
  .van-field {
    padding-left: 5px;
    /deep/.van-field__control {
      color: #ff3c1c;
    }
  }
}
.section-content {
  background-color: #fff;
  border-radius: 16px;
  padding: 0 15px 15px;
  margin-bottom: 40px;
  .sec-title {
    position: relative;
    top: -20px;
    left: -15px;
    height: 45px;
  }
}
* {
  box-sizing: border-box;
}
.head-img {
  width: 100%;
  max-width: 402px;
  margin-top: -30px;
}
.head-img1 {
  width: 100%;
  max-width: 402px;
}
img {
  display: block;
  max-width: 100%;
}
.head-wrap {
  padding: 0px 0 50px;
  overflow: hidden;
  .title {
    width: 298px;
    margin-bottom: 30px;
  }
  .des {
    width: 165px;
  }
}
.content-padding {
  padding-left: 20px;
  padding-right: 20px;
}
.section {
  border-radius: 12px;
  margin-bottom: 16px;
  .sec-title {
  }
  .content {
    padding-top: 20px;
    border-radius: 12px;
  }
}
.input-wrap {
  margin-bottom: 16px;
  .key {
    color: #363636;
    font-size: 14px;
    margin-bottom: 12px;
  }
  .val {
    /deep/ .van-cell {
      border: none;
      background-color: #eaf6fe;
      /deep/input::placeholder {
        color: #b8d7eb !important;
      }
    }
  }
}
.label {
  color: #363636 !important;
  font-size: 14px !important;
  margin-bottom: 12px !important;
}
@font-face {
  font-family: "SongtiSC";
  src: url("../../assets/pdmInfo/fonts/song.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
  /* 可选，用于字体加载期间的替代字体 */
}
@font-face {
  font-family: "songCN";
  src: url("../../assets/pdmInfo/fonts/songCN.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
  /* 可选，用于字体加载期间的替代字体 */
}
img {
  margin: 0;
  display: block;
}
/deep/ .van-cell-group {
}
/deep/ .right-icon {
  width: 18px;
  height: 18px;
}
/deep/ .van-cell {
}
/deep/ .van-field__control::placeholder,
/deep/ .van-cell__title,
/deep/ .van-cell__right-icon {
}
.loadingDiv {
  position: absolute;
  left: 42%;
  top: 40%;
}
.info {
  position: relative;
  padding-bottom: 100px;
  background-color: #bbdefa;
  // background: url(../../assets/pdmInfo/test.png);
  // background-position: top left;
  // background-size: 100% auto;
  // background-repeat: repeat-y;
  // padding: 0 0 100px;
  &-banner {
    width: 100%;
  }
  .manage-info {
    // margin-bottom: 16px;
    overflow: hidden;
    margin-bottom: 20px;
    &-title {
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    &-repeat {
      background-repeat: repeat-y;
      background-size: 100% 100%;
    }
    &_header {
      padding: 20px 16px 5px;
      // text-align: center;
      &.worker-title {
        h4 {
          color: #000;
          font-size: 20px;
          font-weight: 900;
          position: relative;
          padding-bottom: 10px;
          margin-bottom: 10px;
          &:after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            height: 1px;
            background: #000;
            width: 170px;
          }
        }
        p {
          font-size: 14px;
          color: #000;
        }
        img {
          width: 193px;
        }
      }
      &.person-title {
        text-align: right;
        background-repeat: no-repeat;
        background-position: left top;
        background-size: 305px 95px;
        h4 {
          font-size: 20px;
          font-weight: 900;
          color: #000;
          position: relative;
          padding-bottom: 10px;
          margin-bottom: 10px;
          &:after {
            content: "";
            position: absolute;
            right: 0;
            bottom: 0;
            height: 1px;
            background: #000;
            width: 170px;
          }
        }
        p {
          font-size: 14px;
          color: #000;
        }
        img {
          width: 173px;
        }
      }
      // h4 {
      // font-family: AR XinYiGBJF UL;
      // font-size: 18px;
      // color: rgb(0, 150, 104);
      // }
      // p {
      // font-size: 13px;
      // color: rgb(0, 150, 104);
      // }
    }
    &_content {
      // background: #fff;
      // border-radius: 16px;
      padding-top: 20px;
      .link /deep/ .van-cell__title {
        color: #333;
      }
      & > p {
        color: #000;
        font-size: 14px;
        margin-bottom: 10px;
        font-weight: 900;
      }
      /deep/ .van-cell {
        // background: rgb(246, 251, 249);
        // border-radius: 12px;
      }
      /deep/ .van-cell::after {
        border-bottom: none;
      }
      .project-list {
        // border-radius: 12px;
        // padding: 10px;
        // background: linear-gradient(
        // 181.71deg,
        // rgba(149, 244, 215, 1) -381.86%,
        // rgba(255, 255, 255, 1) 125.61%
        // );
        margin: -3px;
        ul {
          display: flex;
          margin-bottom: 6px;
          flex-wrap: wrap;
          flex-wrap: wrap;
          li {
            width: auto;
            position: relative;
            border: 1px solid #b8d7eb;
            border-radius: 8px;
            padding: 6px 9px 4px;
            margin: 3px;
            &.active {
              border: 1px solid #0374c3;
            }
            &.flex-2 {
              padding-left: 3px;
              padding-right: 3px;
            }
            &:last-child {
              margin-right: 0;
            }
            .item-success {
              position: absolute;
              right: -1px;
              top: -1px;
              width: 16px;
              height: 16px;
              img {
                position: absolute;
                width: 100%;
                height: 100%;
              }
            }
            p {
              font-size: 11px;
              color: rgb(255, 60, 28);
              margin: 8px 0;
              text-align: center;
              font-weight: 900;
              &.title {
                font-size: 11px;
                font-weight: 500;
                color: #363636;
                margin: 2px 0;
              }
              &.middle {
                margin: 10px 8px;
                height: 1px;
                background: url("../../assets/huada/line.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
                // background: linear-gradient(
                // 90deg,
                // rgba(255, 255, 255, 1) 0%,
                // rgba(212, 251, 238, 1) 50%,
                // rgba(255, 255, 255, 1) 100%
                // );
              }
            }
          }
        }
      }
      .money {
        &-title {
          color: #363636;
          font-size: 14px;
          margin-bottom: 12px;
        }
        &-info {
          &_content {
            display: flex;
            justify-content: space-between;
            margin: 14px 0;
            span {
              font-size: 13px;
              color: rgb(30, 30, 30);
              font-weight: 400;
              &:last-child {
                color: rgb(255, 60, 28);
              }
            }
          }
        }
        &-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 0;
          border-top: 1px solid #eaf6fe;
          span {
            font-size: 16px;
            font-weight: 900;
            color: rgba(30, 30, 30);
            &:last-child {
              color: rgb(255, 60, 28);
            }
          }
          .discount-display {
            font-size: 13px;
            color: #0374c3;
            margin-left: 8px;
            font-weight: 500;
          }
        }
      }
    }
  }
  .add-info {
    padding: 0 15px 20px;
    background-color: #f7fcff;
    margin-top: -21px;
    border-radius: 0 0 16px 16px;
  }
  .remove-info {
    margin-top: -50px;
    background-color: #fff;
    padding: 15px;
  }
  .add-user {
    background: url("../../assets/huada/btn-add.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 50px;
  }
  .remove-user {
    background: url("../../assets/huada/btn-remove.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 45px;
  }
  &-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    border-radius: 16px 16px 0 0;
    padding: 20px 12px 30px;
    dl {
      dt {
        font-size: 12px;
        color: #000;
      }
      dd {
        font-size: 18px;
        color: rgb(255, 60, 28);
        font-weight: 900;
      }
    }
    &_right {
      font-size: 16px;
      font-weight: 900;
      display: flex;
      .btn {
        width: 111px;
        height: 42px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
      .save {
        background-image: url("../../assets/huada/btn-l.png");
        padding: 7px 40px;
      }
      .pay-now {
        background-image: url("../../assets/huada/btn-r.png");
        padding: 7px 20px;
      }
    }
  }
}
.info {
  background-image: url("../../assets/huada/body-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>
